"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.project.exceeded': 'Osiągnięto limit projektów. Ulepsz swój plan, aby utworzyć więcej projektów.',
    'limits.project.limitReached': 'Limit projektów: {limit} (ulepsz dla więcej)',
};
